module.exports = __webpack_public_path__ + "img/Monte_Kope_2.42e8da34.jpg";